import { render, staticRenderFns } from "./labelManage.vue?vue&type=template&id=d7894124&scoped=true"
import script from "./labelManage.vue?vue&type=script&lang=js"
export * from "./labelManage.vue?vue&type=script&lang=js"
import style0 from "./labelManage.vue?vue&type=style&index=0&id=d7894124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7894124",
  null
  
)

export default component.exports